var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 26.5556H3C1.89543 26.5556 1 25.6601 1 24.5556V3C1 1.89543 1.89543 1 3 1H19C20.1046 1 21 1.89543 21 3V13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9858 17.3161C21.1883 17.1137 21.4628 17 21.7491 17C21.8908 17 22.0312 17.0279 22.1621 17.0822C22.2931 17.1364 22.4121 17.2159 22.5123 17.3161C22.6125 17.4164 22.692 17.5354 22.7463 17.6663C22.8005 17.7973 22.8284 17.9376 22.8284 18.0794C22.8284 18.2211 22.8005 18.3615 22.7463 18.4924C22.692 18.6234 22.6125 18.7424 22.5123 18.8426L17.3344 24.0205L14.9849 26.3699C14.9488 26.4061 14.9035 26.4317 14.854 26.4441L13.3503 26.82C13.2542 26.844 13.1526 26.8159 13.0826 26.7458C13.0126 26.6758 12.9844 26.5742 13.0084 26.4781L13.3843 24.9745C13.3967 24.9249 13.4224 24.8796 13.4585 24.8435L20.9858 17.3161Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13L16 13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8L16 8",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18L12 18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/contract-icon.556dfbbc4bcbe9f5107729bce7774a20.svg";
export { ForwardRef as ReactComponent };